<template>
  <div class="flex flex-col gap-6 min-h-screen">
    <div class="text-center">
      <h3 class="text-xl font-bold">
        {{ $t("totalForm.step4.title") }}
      </h3>
      <p class="text-gray-600 max-w-md mx-auto mt-2">
        {{ $t("totalForm.step4.desc") }}
      </p>
    </div>

    <!-- Cal inline embed iframe - flex grow to fill space -->
    <div class="flex-1 w-full">
      <iframe
        ref="calFrame"
        :src="`https://cal.com/siteoplossing/totalpackage?name=${encodeURIComponent(
          name
        )}&email=${encodeURIComponent(email)}`"
        width="100%"
        height="100%"
        style="border: none; min-height: 700px"
        frameborder="0"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        title="Cal.com Scheduler"
      ></iframe>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";

// Define Cal.com postMessage payload interface
interface CalMessage {
  originator: string;
  type: string;
  fullType: string;
  data: { booking: any };
}

const props = defineProps<{ name: string; email: string; need: string }>();
const { name, email, need } = props;
const router = useRouter();

function handleCalMessage(event: MessageEvent) {
  // Only accept messages from Cal.com
  if (!(event.origin || "").includes("cal.com")) return;

  const msg = event.data as CalMessage;
  const { type, fullType } = msg;

  // Capture booking success events
  if (
    type === "bookingSuccessful" ||
    fullType === "CAL::bookingSuccessful" ||
    type === "cal.booked" ||
    type === "booking.created"
  ) {
    // Store booking payload for the confirmation page
    sessionStorage.setItem("bookingData", JSON.stringify(msg.data.booking));

    // Redirect by explicit path (guaranteed to match)
    router.push("/consultation-confirmed").catch((err) => {
      window.location.href = "/consultation-confirmed";
    });
  }
}

onMounted(() => window.addEventListener("message", handleCalMessage));
onBeforeUnmount(() => window.removeEventListener("message", handleCalMessage));
</script>

<style scoped>
/* Ensure iframe fills the flex container */
iframe {
  width: 100%;
  height: 100%;
}

/* tweak iframe min-height for smaller viewports */
@media (max-width: 640px) {
  iframe {
    min-height: 600px;
  }
}
</style>
